import React, { Component } from 'react';
import { connect } from 'react-redux';
import { filter } from 'lodash';
import {
  onClickActivateButton,
  onClickShowOutletDetailModal,
  onClickTermsAndConditions,
  setSelectedPaymentMethodList,
  activateAllPaymentMethod,
  activateRemainingPaymentMethod,
  activateRemainingNewOutlet,
} from 'actions/setting/paymentMethod';
import { PAYMENT_METHOD_KEY } from 'utils/paymentMethodConstants';
import { reduxForm, getFormValues } from 'redux-form';
import OvoImageIcon from './images/ovo-button.png';
import LinkAjaImageIcon from './images/linkaja-logo.png';
import AkulakuImageIcon from './images/akulaku-logo.png';
import KredivoImageIcon from './images/kredivo-logo.png';
import DanaImageIcon from './images/dana-logo.png';
import GoPayImageIcon from './images/gopay-logo.png';
import AlipayImageIcon from './images/alipay-logo.png';
import WechatpayImageIcon from './images/wechatpay-logo.png';
import styles from './styles.css';

class PaymentMethodList extends Component {
  componentDidMount() {
    this.props.dispatch(setSelectedPaymentMethodList([]));
  }

  _getEWalletTransactionFee = key => {
    switch (key) {
      case PAYMENT_METHOD_KEY.OVO:
        return '1,5%';
      case PAYMENT_METHOD_KEY.TCASH:
        return '0,7%';
      case PAYMENT_METHOD_KEY.AKULAKU:
        return '1%';
      case PAYMENT_METHOD_KEY.KREDIVO:
        return '2%';
      case PAYMENT_METHOD_KEY.DANA:
        return '0,7%';
      case PAYMENT_METHOD_KEY.GOPAY:
        return '0,7%';
      case PAYMENT_METHOD_KEY.ALIPAY:
        return '2%';
      case PAYMENT_METHOD_KEY.WECHATPAY:
        return '2%';
    }
  };

  _getEWalletIconImage = key => {
    switch (key) {
      case PAYMENT_METHOD_KEY.OVO:
        return OvoImageIcon;
      case PAYMENT_METHOD_KEY.TCASH:
        return LinkAjaImageIcon;
      case PAYMENT_METHOD_KEY.AKULAKU:
        return AkulakuImageIcon;
      case PAYMENT_METHOD_KEY.KREDIVO:
        return KredivoImageIcon;
      case PAYMENT_METHOD_KEY.DANA:
        return DanaImageIcon;
      case PAYMENT_METHOD_KEY.GOPAY:
        return GoPayImageIcon;
      case PAYMENT_METHOD_KEY.ALIPAY:
        return AlipayImageIcon;
      case PAYMENT_METHOD_KEY.WECHATPAY:
        return WechatpayImageIcon;
    }
  };

  _onClickActivatePaymentMethod = () => {
    const { selectedPaymentMethodList, userData, businessName } = this.props;
    this.props.dispatch(
      onClickActivateButton(selectedPaymentMethodList, userData, businessName)
    );
  };

  _onSelectPaymentMethod = paymentMethod => () => {
    let { selectedPaymentMethodList } = this.props;
    const found = selectedPaymentMethodList.some(function(el) {
      return el.id === paymentMethod.id;
    });

    if (!found) {
      selectedPaymentMethodList.push(paymentMethod);
    } else {
      selectedPaymentMethodList = filter(selectedPaymentMethodList, function(
        item
      ) {
        return item.id !== paymentMethod.id;
      });
    }
    this.props.dispatch(
      setSelectedPaymentMethodList(selectedPaymentMethodList)
    );
  };

  _disableActivateButton = () => {
    const { selectedPaymentMethodList, formValues } = this.props;
    if (selectedPaymentMethodList.length > 0 && formValues) {
      const { agreement } = formValues;
      if (agreement) {
        return !agreement;
      }
    }
    return true;
  };

  activatePaymentMethods = () => {
    this.props.dispatch(
      activateAllPaymentMethod({
        business: this.props.userData.business,
        outlets: this.props.outlets,
        outletStatus: this.props.outletStatus,
        paymentMethods: this.props.paymentMethods,
      })
    );
  };

  activeRemainingPaymentMethods = () => {
    this.props.dispatch(
      activateRemainingPaymentMethod({
        business: this.props.userData.business,
        outlets: this.props.outlets,
        outletStatus: this.props.outletStatus,
        paymentMethods: this.props.paymentMethods,
      })
    );
  };

  activeRemainingNewOutlets = () => {
    this.props.dispatch(
      activateRemainingNewOutlet({
        business: this.props.userData.business,
        outlets: this.props.outlets,
        outletStatus: this.props.outletStatus,
        paymentMethods: this.props.paymentMethods,
      })
    );
  };

  isObjectEmpty = obj => {
    if (!obj) {
      return true;
    }
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return JSON.stringify(obj) === JSON.stringify({});
  };

  showActivateMobileBtn = () => {
    const { activatePaymentStatus } = this.props;
    const {
      is_kyb_registration_completed: kybStatus,
    } = this.props.userData.business;
    return (
      !kybStatus &&
      (activatePaymentStatus &&
        activatePaymentStatus !== 'ALL_OUTLET_REGISTERED')
    );
  };

  showActivateRemainingMobileBtn = () => {
    const { activatePaymentStatus, kybStatus } = this.props;
    return (
      kybStatus === 'approved' &&
      activatePaymentStatus &&
      activatePaymentStatus === 'PAYMENT_METHOD_PARTIALLY_REGISTERED'
    );
  };

  showActivateRemainingOutletBtn = () => {
    const { activatePaymentStatus, kybStatus } = this.props;
    return (
      kybStatus === 'approved' &&
      activatePaymentStatus &&
      (activatePaymentStatus === 'OUTLET_PARTIALLY_REGISTERED' ||
        activatePaymentStatus === 'ALL_OUTLET_NOT_REGISTERED')
    );
  };

  render() {
    const {
      paymentMethods,
      outletStatus,
      outlets,
      userData,
      isSubscribed,
    } = this.props;
    if (!paymentMethods || !outletStatus || !outlets || !userData) {
      return <div />;
    }

    const termsAndCond = isSubscribed;

    return (
      <div>
        <div className="row">
          <div className="col-md-6 col-lg-6 col-sm-12">
            <div className={styles['mk-section-header']}>
              {`Activate Payment Method`}
            </div>
          </div>
        </div>
        <div className="row">
          <div className={`col-md-6 ${styles.description}`}>
            <div>{`Start accepting e-wallet payment so your customers can pay with their e-wallet app at your outlets.`}</div>
            <div className={styles['contact-us']}>
              Please contact us at{' '}
              <a
                href="tel:1500970"
                className={styles['phone-number']}
              >{`1500970`}</a>{' '}
              for more info.
            </div>
          </div>
        </div>

        <div className="row">
          <div className={`col-md-6`}>
            {this.showActivateMobileBtn() && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.activatePaymentMethods}
              >
                Activate Mobile Payment
              </button>
            )}
            {this.showActivateRemainingMobileBtn() && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.activeRemainingPaymentMethods}
              >
                Activate Remaining Mobile Payment
              </button>
            )}
            {this.showActivateRemainingOutletBtn() &&
              !this.showActivateRemainingMobileBtn() && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.activeRemainingNewOutlets}
                >
                  Activate Remaining Outlet
                </button>
              )}
          </div>
        </div>

        <div className={`row ${styles['space-30px']} ${styles['mb-10px']}`}>
          <div className={`col-md-12`}>
            <table className={styles['table-header']}>
              <thead>
                <tr>
                  <th>{`Payment Method`}</th>
                  <th className={`text-center`}>{`MDR`}</th>
                  <th>{`Settlement Date`}</th>
                  <th className={`text-center`}>{`Terms`}</th>
                  <th className={`text-center`}>{`Status`}</th>
                  <th />
                </tr>
              </thead>
            </table>
            <div className={styles['table-content-wrapper']}>
              <table className={styles['table-content']}>
                <tbody>
                  {paymentMethods.length > 0 &&
                    paymentMethods.map((paymentMethod, idx) => {
                      let countPending = 0;
                      let activeOutlet = 0;
                      let countInactive = 0;
                      let countRejected = 0;
                      outlets.map(outlet => {
                        try {
                          const status =
                            outletStatus[paymentMethod.id][outlet.id];
                          switch (status) {
                            case 'APPROVED':
                              activeOutlet++;
                              break;
                            case 'PENDING':
                              countPending++;
                              break;
                            case 'REJECTED':
                              countRejected++;
                              break;
                            default:
                              countInactive++;
                              break;
                          }
                        } catch (error) {
                          countInactive++;
                        }
                      });
                      return (
                        <tr key={idx}>
                          <td style={{ padding: '0 !important' }}>
                            <img
                              src={this._getEWalletIconImage(
                                paymentMethod.code
                              )}
                            />
                            <span
                              className={styles['payment-method-name-spacing']}
                            >
                              {paymentMethod.name}
                            </span>
                          </td>
                          <td className={`text-center`}>
                            {this._getEWalletTransactionFee(paymentMethod.code)}
                          </td>
                          <td>{`Settlement in 1 business day`}</td>
                          <td>
                            {termsAndCond && (
                              <button
                                className="btn btn-link btn-block btn-primary btn-xs"
                                onClick={() => {
                                  this.props.dispatch(
                                    onClickTermsAndConditions(paymentMethod)
                                  );
                                }}
                              >{`Terms & Conditions`}</button>
                            )}
                          </td>
                          <td className={`${styles['text-center']}`}>
                            {!this.isObjectEmpty(
                              outletStatus[paymentMethod.id]
                            ) ? (
                              <div>
                                <div>
                                  {countInactive > 0 && (
                                    <span
                                      className={`${styles['inactive-outlet']}`}
                                    >
                                      Inactive ({countInactive})<br />
                                    </span>
                                  )}
                                  {countPending > 0 && (
                                    <span
                                      className={`${styles['pending-outlet']}`}
                                    >
                                      Waiting for approval ({countPending})
                                      <br />
                                    </span>
                                  )}
                                  {countRejected > 0 && (
                                    <span
                                      className={`${styles['rejected-outlet']}`}
                                    >
                                      Not Approved ({countRejected})<br />
                                    </span>
                                  )}
                                  {activeOutlet > 0 && (
                                    <span
                                      className={`${styles['active-outlet']}`}
                                    >
                                      Active ({activeOutlet})
                                    </span>
                                  )}
                                </div>
                              </div>
                            ) : (
                              <span className={`${styles['inactive-outlet']}`}>
                                Inactive
                              </span>
                            )}
                          </td>
                          <td>
                            {!this.isObjectEmpty(
                              outletStatus[paymentMethod.id]
                            ) ? (
                              <div>
                                <button
                                  className="btn btn-default btn-block"
                                  style={{ color: '#3e8acc' }}
                                  onClick={() => {
                                    this.props.dispatch(
                                      onClickShowOutletDetailModal(
                                        paymentMethod
                                      )
                                    );
                                  }}
                                >{`View Details`}</button>
                              </div>
                            ) : null}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    assignedOutlets,
    paymentMethodOutlets,
    paymentMethods,
    outletStatus,
    outlets,
    bankAccountData,
    selectedPaymentMethodList,
    mdrPaymentMethod,
    activatePaymentStatus,
    kybStatus,
  } = state.setting.paymentMethod;
  return {
    isSubscribed: state.moka.user.already_subscribed,
    subscriptionExpired: state.subscriptionExpired,
    paymentMethods,
    outletStatus,
    outlets,
    bankAccountData,
    assignedOutlets,
    paymentMethodOutlets,
    selectedPaymentMethodList,
    mdrPaymentMethod,
    userData: state.moka.user,
    businessName: state.moka.user.business.name,
    activatePaymentStatus,
    kybStatus,
    formValues: getFormValues('paymentMethodBulkRegistrationForm')(state),
  };
}

const mapForm = {
  form: 'paymentMethodBulkRegistrationForm',
};

export default connect(mapStateToProps)(reduxForm(mapForm)(PaymentMethodList));
